import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {RoutesViewSettingsResourcesModel} from "../../models/routes-view-settings.model";

export class RoutesViewResourcesSettingsPanelComponent implements IController {

  settings: RoutesViewSettingsResourcesModel;
  onSettingsChange: Function;

  constructor(private $mdPanel) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const settingsRef = this.settings;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<routes-view-resources-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" settings="ctrl.settings">' +
        '</routes-view-resources-settings-panel-template>',
      controller: function () {
        this.settings = settingsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason, updatedSettings) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    this.onSettingsChange({
      settings: settingsConfig
    })
  }

  onSubmit(settings) {
    this.onSettingsChange({settings: settings});
  }

  onReset() {
    // const settingsConfig = this.splitService.getSiteAgentsSettings(this.splitService.getSiteId());
    // this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({settings: this.settings});
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesViewResourcesSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./routes-view-resources-settings-panel.html').default,
    controller: RoutesViewResourcesSettingsPanelComponent
  });
